<template>
  <header class="top-bar">
    <div class="top-bar__left">
      <h1 class="top-bar__section-title">{{ sectionTitle }}</h1>
    </div>

    <div class="top-bar__centre"></div>

    <div class="top-bar__right">
      <NotificationBell @toggle="$emit('toggle-notifications')" />
      <HelpButton @toggle="$emit('toggle-help')" />
    </div>
  </header>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import NotificationBell from './NotificationBell.vue'
import HelpButton from './HelpButton.vue'

export default defineComponent({
  name: 'TopBar',
  components: { NotificationBell, HelpButton },
  props: {
    sectionTitle: {
      type: String,
      default: '',
    },
  },
  emits: ['toggle-notifications', 'toggle-help'],
})
</script>

<style scoped>
.top-bar {
  height: 64px;
  min-height: 64px;
  display: flex;
  align-items: center;
  padding: 0 28px;
  background: #181b2f;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  gap: 16px;
  box-sizing: border-box;
  font-family: var(--font-sans);
}

.top-bar__left {
  flex: 0 0 auto;
  min-width: 0;
}

.top-bar__section-title {
  font-size: 20px;
  font-weight: 700;
  color: #ffffff;
  margin: 0;
  white-space: nowrap;
  font-family: var(--font-sans);
  letter-spacing: -0.01em;
}

.top-bar__centre {
  flex: 1;
  display: flex;
  justify-content: center;
}

.top-bar__search-pill {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 16px;
  background: rgba(255, 255, 255, 0.06);
  border-radius: 29px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  cursor: not-allowed;
  opacity: 0.55;
  max-width: 280px;
  width: 100%;
}

.top-bar__search-kbd {
  font-size: 11px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.5);
  background: rgba(255, 255, 255, 0.08);
  border-radius: 4px;
  padding: 1px 5px;
  flex-shrink: 0;
  font-family: var(--font-sans);
}

.top-bar__search-placeholder {
  font-size: 13px;
  font-weight: 300;
  color: rgba(255, 255, 255, 0.4);
  white-space: nowrap;
  font-family: var(--font-sans);
}

.top-bar__right {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 6px;
}

/* Mobile / narrow viewport polish */
@media (max-width: 768px) {
  .top-bar {
    padding: 0 14px;
    gap: 8px;
  }
  .top-bar__section-title {
    font-size: 17px;
  }
  /* Hide the search pill on mobile — it's a slot for future and crowds the bell + help */
  .top-bar__centre {
    display: none;
  }
}
</style>
